import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { InviteWorkerRequest } from '../models/invite-worker-request.model';
import { InviteWorkerResponse } from '../models/invite-worker-response.model';
import { Worker } from '../models/worker.model';
import { CurrentUser } from '../models/current-user.model';
import { environment } from 'src/app/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  // ✅ Use environment.apiUrl
  private api = `${environment.apiUrl}/api/users`;

  constructor(private http: HttpClient) {}

  inviteWorker(request: InviteWorkerRequest): Observable<InviteWorkerResponse> {
    return this.http.post<InviteWorkerResponse>(`${this.api}/invite`, request);
  }

  getWorkers(): Observable<Worker[]> {
    return this.http.get<Worker[]>(`${this.api}/workers`);
  }

  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.api}/me`);
  }

}